import type { ModuleDef } from "../types";
import { MATERIAL_BLOCKS } from "../materials";
import { ENGINES } from "./engines";
import { REACTORS } from "./reactors";
import { STRUCTURAL } from "./structural";
import { SUPPORT } from "./support";
import { WEAPONS } from "./weapons";

const ALL: ModuleDef[] = [
  ...STRUCTURAL,
  ...REACTORS,
  ...ENGINES,
  ...WEAPONS,
  ...SUPPORT,
  ...MATERIAL_BLOCKS,
];

const BY_ID = new Map<string, ModuleDef>(ALL.map((m) => [m.id, m]));

export function getModuleDef(id: string): ModuleDef {
  const def = BY_ID.get(id);
  if (!def) throw new Error(`unknown module id: ${id}`);
  return def;
}

export function listModules(): readonly ModuleDef[] {
  return ALL;
}

export { defineModule } from "./define";

